import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AppRoutes } from '@shared/constants/app-routes.const';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  isOidcModuleReady = false;
  public onOidcModuleSetup: Observable<true>;

  constructor(private oidcSecurityService: OidcSecurityService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | Observable<boolean> {
    return this.oidcSecurityService.isAuthenticated$.pipe(
      map(isAuthorized => {
        if (!isAuthorized.isAuthenticated) {
          this.router
            .navigate([AppRoutes.LOGIN], {
              queryParams: {
                returnUrl: window.location.href,
              },
            })
            .then();
        }
        return isAuthorized.isAuthenticated;
      })
    );
  }
}
